<template>
  <BaseLink
    :class="classes"
    :link="link"
    :component-type="componentType"
    :target="target"
    :tabindex="tabindex"
    :qa-locator="qaLocator"
  >
    <SvoiTooltippedIcon v-if="iconLeft" :icon="iconLeft" :size="iconSize" class="icon-left" />

    <slot name="name" :bindClass="'name'">
      <span v-if="name" class="name">{{ name }}</span>
    </slot>

    <SvoiTooltippedIcon v-if="iconRight" :icon="iconRight" :size="iconSize" class="icon-right" />
  </BaseLink>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi'
import { SvoiTooltippedIcon } from '@svoi-ui/components/icon'
import type { Target } from '@svoi-ui/interfaces/button'
import { isString } from '@svoi-ui/shared/utils/guards'
import { linkLocator } from '@svoi-ui/shared/utils/helpers'
import { BaseButtonComponent, useBaseButton } from './BaseButton'
import BaseLink from './BaseLink.vue'

export default defineComponent({
  name: 'SvoiButtonLink',
  components: { SvoiTooltippedIcon, BaseLink },
  props: {
    ...BaseButtonComponent.props,
    ...BaseLink.props,
    target: {
      type: String as PropType<Target | string>,
      default: '_self',
      validator: (value: unknown) => {
        return isString(value) && ['_blank', '_parent', '_self', '_top'].includes(value)
      }
    }
  },
  setup(props) {
    const { classes, iconSize } = useBaseButton(props)

    const qaLocator = computed(() => (props.qaLocator ? linkLocator(props.qaLocator) : undefined))

    return { classes, iconSize, qaLocator }
  },
  methods: { isString }
})
</script>

<style lang="scss">
@use '@svoi-ui/assets/scss/components/button.scss';
</style>
